module.exports = __webpack_public_path__ + "static/img/evolucao-sentimento-barras.0b32e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-sentimento-barras.png
// module id = ZrEt
// module chunks = 1